var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.value, persistent: "", "max-width": "700px" },
      on: { "click:outside": _vm.closeModal },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c("v-icon", { attrs: { color: "primary" } }, [
                _vm._v("mdi-store"),
              ]),
              _c("span", { staticClass: "pl-2" }, [
                _vm._v(_vm._s(_vm.storeParty.store_name)),
              ]),
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { icon: "" }, on: { click: _vm.closeModal } },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              items: _vm.stores,
              height: 250,
              "items-per-page": -1,
              dense: "",
              "hide-default-footer": "",
            },
            scopedSlots: _vm._u([
              {
                key: "item.store_name",
                fn: function ({ item }) {
                  return [
                    _c("td", { staticClass: "noWrap" }, [
                      _vm._v(_vm._s(item.store_name)),
                    ]),
                  ]
                },
              },
              {
                key: "item.start_dt",
                fn: function ({ item }) {
                  return [
                    _c("td", { staticClass: "noWrap" }, [
                      _vm._v(_vm._s(_vm.formatDateDisplay(item.start_dt))),
                    ]),
                  ]
                },
              },
              {
                key: "item.end_dt",
                fn: function ({ item }) {
                  return [
                    _c("td", { staticClass: "noWrap" }, [
                      _vm._v(_vm._s(_vm.formatDateDisplay(item.end_dt))),
                    ]),
                  ]
                },
              },
              {
                key: "item.created_on",
                fn: function ({ item }) {
                  return [
                    _c("td", { staticClass: "noWrap" }, [
                      _vm._v(_vm._s(_vm.formatDateDisplay(item.created_on))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("label", { staticClass: "font-weight-light mx-2" }, [
            _vm._v(
              "Note: The primary store of a store group is determined by the store relationship's start date."
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }